import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormPrivateEventComponent from '../components/FormPrivateEventComponent';
import { validateSession } from '../utils/functions';

// El alta de un evento privado (cumpleaños, festejos) en una pantalla. Acá sólo está el marco:
// el formulario, con todo lo que pide y manda, es `FormPrivateEventComponent`.
class AddPrivateEventPage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0 };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={33} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Eventos" subtitle="Evento privado" />
                            <FormPrivateEventComponent />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddPrivateEventPage;
